import React from 'react';
import ChargebacksComponent from './chargeback.list.component';

const ChargeBacks = (props) => {
    return <ChargebacksComponent {...props} />;
};
export default ChargeBacks;
